// Import medal image
import GoldMedal from "../../assets/NewBanner/BlackCoin.png";
import DoubleGold from "../../assets/NewBanner/DoubleGold.png";
import SilverMedal from "../../assets/NewBanner/SilverMedal.png";
import BronzeMedal from "../../assets/NewBanner/BronzeMedal.png";
// Import product images
import PaaniVodka from "../../assets/NewBanner/PaaniVodka.svg";
import PotatoVodka from "../../assets/NewBanner/PotatoVodka.svg";
import BaelVodka from "../../assets/NewBanner/BaelVodka.svg";
import JamunVodka from "../../assets/NewBanner/JamunVodka.svg";

/**
 * Award card data for different product configurations
 */
export const awardCardData = {
  // Single product example
  singleProductOne: {
    award: {
      medalImage: DoubleGold,
      title: "Double - Gold",
      description:
        "Awarded to a spirit of superior quality in which every judge on the panel independently gave a score of at least 90 and for which the panel believes the spirit to be of exceptional quality for its class and category."
    },
    products: [
      {
        name: "Tharra Company Paani Vodka (36%, Idaho, USA)",
        image: PaaniVodka
      }
    ]
  },
  singleProductTwo: {
    award: {
      medalImage: GoldMedal,
      title: " Best of Category – Bottled & Blended – Flavored Vodka",
      description:
        "Given to the single highest-ranked spirit within a category (e.g., Flavored Vodka) that has earned at least a Silver medal and is judged as the best representation of its class."
    },
    products: [
      {
        name: "Tharra Company Paani Vodka (36%, Idaho, USA)",
        image: PaaniVodka
      }
    ]
  },

  // Dual product example  Best of Category – Bottled & Blended – Flavored Vodka
  dualProductsOne: {
    award: {
      medalImage: SilverMedal,
      title: "Silver Medals",
      description:
        "A Silver Medal is awarded to spirits that are outstanding and show excellent balance, flavor, and quality."
    },
    products: [
      {
        name: "Tharra Company Potato Vodka (41%, Idaho, USA)",
        image: PotatoVodka
      },
      {
        name: "Tharra Company Paani Vodka (36%, Idaho, USA)",
        image: PaaniVodka
      }
    ]
  },

  dualProductsTwo: {
    award: {
      medalImage: BronzeMedal,
      title: "Bronze Medals",
      description:
        "A Bronze Medal is awarded to well-crafted spirits that stand out as solid examples of their category."
    },
    products: [
      {
        name: "Tharra Company Jamun Vodka (36%, Idaho, USA)",
        image: JamunVodka
      },
      {
        name: "Tharra Company Bael Vodka (36%, Idaho, USA)",
        image: BaelVodka
      }
    ]
  }
};

/**
 * Example of how to use the data:
 *
 * import AwardCard from './components/AwardCard';
 * import { awardCardData } from './components/AwardCard/awardCardData';
 *
 * // For a single product card
 * <AwardCard {...awardCardData.singleProduct} />
 *
 * // For a dual product card
 * <AwardCard {...awardCardData.dualProducts} />
 */
